import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { PublisherUserAuthenticationService } from '../_services/authentication.service';
import { Observable } from 'rxjs';
import { Helpers } from '../../../helpers';
import { DataService } from '../../../_services/data.service';
import { Roles } from '../../../models/enums';

@Injectable()
export class PublisherAdminAuthGuard implements CanActivate {
    constructor(private _router: Router, private dataService: DataService) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        const roles = this.dataService.roles;
        var isInRole = roles.includes(Roles.Admin);
        if (!isInRole) {
            this._router.navigate(['/publisher/forbidden-error']);
        }
        return isInRole;
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/_guards/admin.guard.ts